import React, {Component} from "react";
import {NotificationsContext} from "./NotificationsProvider";
import {Notification as GrommetNotification} from "grommet";
import {signOutAndClearAdminUser} from "../utils/router";

class Notification extends Component {
    static contextType = NotificationsContext

    hasSignedOut = false;

    constructor(props) {
        super(props)
    }

    componentDidMount() {
        this.isUnauthorizedError(this.context?.notification)
    }

    componentDidUpdate() {
        // The 401/503 notification usually arrives after mount (via context),
        // so check on update too. Previously this was triggered from render(),
        // which fired signOut on every re-render and produced a storm of
        // redirects to /session/signin.
        this.isUnauthorizedError(this.context?.notification)
    }

    isUnauthorizedError = (notification) => {
        if (this.hasSignedOut) return;
        if (notification && [401,503].includes(notification.status)) {
            this.hasSignedOut = true;
            return signOutAndClearAdminUser();
        }
    }

    render() {
        const { notification, hideNotification} = this.context || {};
        return (
            <>
                {notification && <GrommetNotification
                    toast
                    status={notification.type === "error" ? "critical" : "normal"}
                    title={notification?.message}
                    onClose={hideNotification}
                />}
            </>
        )
    }
}

export default Notification
